import axios from "axios";
import store from "../index";
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import {discount,discountPercent} from '../../Helper'
const state = {
    packagings:[],
    packaging : {},
    index:'',
    sortBy:'',
    sortDesc:''



};

const getters = {
    getPackagings: state => {
        return state.packagings;
    },
    getPackaging: state => {
        return state.packaging;
    },
    getIndex: state => {
        return state.index;
    },
    getSortBy: state => {
        return state.sortBy;
    },
    getSortDesc: state => {
        return state.sortDesc;
    },



};

const actions = {

    asyncFetchData : async (context,settings) => {

        const {sortBy, sortDesc, page, itemsPerPage} = settings.options;
        let url = "packagings";

        context.commit('setSortDesc', sortDesc[0]);
        context.commit('setSortBy', sortBy[0]);
        //console.log(context.rootGetters['categories/getSortBy'])

        return await   axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': {
                    "sortBy": context.rootGetters['packagings/getSortBy'],
                    'sortDesc': context.rootGetters['packagings/getSortDesc'],
                    'page': page,
                    'itemsPerPage': itemsPerPage,
                    'filters': (settings.filters)?settings.filters:'',
                    'search': settings.search
                }
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {

                //console.log(res.data.pagination);
                context.commit('setPackagings', res.data.data);
                return res.data.pagination
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });

    },
    setUpdateStatus : async (context,payload) =>{
        //console.log("parent",payload)
        //console.log(payload)
        let url = "packagings/update/status";
        return await   axios.put(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': payload
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {
                //console.log(res.data);
                //context.commit('setCategories', res.data.data);
                return {data:res.data}
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });
    },

    deletePackaging : async (context,settings) => {


        let url = "packagings/delete";


        //console.log(context.rootGetters['categories/getSortBy'])
        return await   axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': {
                    "query": settings
                }
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            }
        )

            .then(res => {
                return res.data
            })
            .catch(err => {
                console.log("errore", err.response.status);
                return {error:err.response.status}

            });

    },

    getDetail : async (context,payload) =>{
        //console.log(payload)
        let url = `packagings/detail/${payload}`;


        return await   axios.get(`${context.rootGetters['settings/getUrl']}${url}`,

            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {
                //console.log(res);
                context.commit('setPackaging', res.data.data);
                return {data:res.data}
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
              /*  if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });
    },
    getListings : async (context,payload) =>{
        //console.log(payload)
        let url = `packagings/list`;


        return await   axios.get(`${context.rootGetters['settings/getUrl']}${url}`,

            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {
                //console.log(res);

                return {data:res.data.data}
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*  if (err.response.status === 401) {

                      //this.setLogout();
                      context.commit('profile/setLogout', {}, {root: true})
                      this.$router.push('/login')
                  }
                  throw Error(err.response.status + ":Posts Not Found");*/
            });
    },



    destroyData : (context) =>{
        context.commit('setPackagings',[]);
        context.commit('setPackaging',[]);

    },


};

const mutations = {
    setPackagings: (state,value) => {
        state.packagings= value;
    },

    setPackaging: (state,value) => {
        state.packaging= value;
    },
    setSortBy: (state,value) => {
        state.sortBy= value;
    },
    setIndex: (state,value) => {
        state.index= value;
    },
    setSortDesc: (state,value) => {
        state.sortDesc= value;
    }



};



export default {
    namespaced : true,
	state,
	mutations,
	getters,
	actions
}
